import React from 'react';
import { SlideLayout } from './SlideLayout';
import { Star, Sparkles } from 'lucide-react';
export function Slide7_Tiers() {
  const advantagePoints = ['Campaign success ambassadors', 'Campaign success manager', 'Two-day live sales school', 'Active KPI tracking', 'Ongoing consulting and campaign performance enhancement'];
  const tiers = [{
    name: 'EDGE',
    role: 'Infrastructure',
    description: 'Predictable applicant flow and pre-screening.',
    keyPoints: ['HIRE handles traffic and screening', 'You handle interviews and hiring'],
    bestFor: 'Teams with strong internal hiring who want better candidates.'
  }, {
    name: 'ADVANTAGE',
    role: 'System Ownership',
    description: 'A recruiting system that actually works.',
    keyPoints: advantagePoints,
    highlight: true,
    bestFor: 'Teams that want consistency without giving up execution.'
  }, {
    name: 'SUMMIT',
    role: 'Full Execution',
    description: 'Recruiting execution handled for you.',
    keyPoints: advantagePoints,
    extraPoints: ['Dedicated recruiter capacity', 'Final interview execution', 'Enhanced pipeline management and onboarding support'],
    amber: true,
    bestFor: 'Teams that want recruiting off their plate.'
  }];
  return <SlideLayout data-id="element-284">
      <div className="flex flex-col h-full justify-center space-y-16" data-id="element-285">
        <div className="space-y-4 text-center" data-id="element-286">
          <h2 className="text-4xl md:text-5xl font-bold text-white" data-id="element-287">
            Three Levels of Partnership
          </h2>
          <p className="text-xl text-slate-400 max-w-3xl mx-auto" data-id="element-288">
            Designed to Support Where Your Business Is At Now and In the Future.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 items-end max-w-6xl mx-auto" data-id="element-289">
          {tiers.map((tier, idx) => {
          const containerClasses = tier.highlight ? 'bg-slate-800/50 border-[#7FE0C3]/50 ring-2 ring-[#7FE0C3]/20 shadow-2xl' : tier.amber ? 'bg-slate-800/50 border-amber-500/50 ring-2 ring-amber-500/20 shadow-2xl' : 'bg-slate-900/30 border-slate-800';
          const rolePillClasses = tier.highlight ? 'bg-[#7FE0C3]/20 text-[#7FE0C3]' : tier.amber ? 'bg-amber-500/20 text-amber-400' : 'bg-slate-800 text-slate-400';
          const bulletClasses = tier.highlight ? 'bg-[#7FE0C3]' : tier.amber ? 'bg-amber-500/60' : 'bg-slate-600';
          return <div key={idx} className={`flex flex-col rounded-xl border transition-all relative p-8 ${containerClasses}`} data-id="element-290">
                {tier.highlight && <div className="absolute -top-3 left-1/2 -translate-x-1/2 px-3 py-1 bg-[#7FE0C3] text-[#163A5F] text-xs font-bold uppercase tracking-wider rounded-full flex items-center space-x-1.5" data-id="element-291">
                    <Star size={12} fill="currentColor" data-id="element-292" />
                    <span data-id="element-293">Most Popular</span>
                  </div>}
                {tier.amber && <div className="absolute -top-3 left-1/2 -translate-x-1/2 px-3 py-1 bg-amber-500 text-slate-950 text-xs font-bold uppercase tracking-wider rounded-full flex items-center space-x-1.5" data-id="element-294">
                    <Sparkles size={12} fill="currentColor" data-id="element-295" />
                    <span data-id="element-296">Full Execution</span>
                  </div>}

                <div className="mb-6" data-id="element-297">
                  <h3 className="text-3xl font-bold text-white mb-3" data-id="element-298">
                    {tier.name}
                  </h3>
                  <span className={`inline-block px-3 py-1.5 rounded-full text-xs font-bold uppercase tracking-wider ${rolePillClasses}`} data-id="element-299">
                    {tier.role}
                  </span>
                </div>

                <p className="text-slate-300 text-lg mb-8 leading-relaxed" data-id="element-300">
                  {tier.description}
                </p>

                <div className="mb-8" data-id="element-301">
                  {tier.extraPoints && <div className="mb-6 p-4 rounded-lg bg-amber-500/10 border border-amber-500/40 space-y-3" data-id="element-302">
                      <div className="flex items-center text-amber-400 text-xs font-bold uppercase tracking-wider" data-id="element-303">
                        <Sparkles size={12} className="mr-2" data-id="element-304" />
                        <span data-id="element-305">Summit Difference</span>
                      </div>
                      {tier.extraPoints.map((point, pIdx) => <div key={pIdx} className="flex items-start" data-id="element-306">
                          <span className="mr-3 mt-1.5 h-1.5 w-1.5 rounded-full flex-shrink-0 bg-amber-400" data-id="element-307" />
                          <span className="text-white font-medium" data-id="element-308">
                            {point}
                          </span>
                        </div>)}
                    </div>}

                  <div className="space-y-3" data-id="element-309">
                    {tier.keyPoints.map((point, pIdx) => <div key={pIdx} className="flex items-start" data-id="element-310">
                        <span className={`mr-3 mt-1.5 h-1.5 w-1.5 rounded-full flex-shrink-0 ${bulletClasses}`} data-id="element-311" />
                        <span className="text-slate-300" data-id="element-312">{point}</span>
                      </div>)}
                  </div>
                </div>

                <div className={`pt-6 border-t ${tier.amber ? 'border-amber-500/20' : 'border-slate-800'}`} data-id="element-313">
                  <p className="text-sm text-slate-400 leading-relaxed" data-id="element-314">
                    {tier.bestFor}
                  </p>
                </div>
              </div>;
        })}
        </div>
      </div>
    </SlideLayout>;
}